import Moment from 'react-moment'
import moment from 'moment/moment'
import React from 'react'

const createTimeDiffTag = createdDate => {
  let result = <Moment format="DD/MM/YYYY HH:mm:ss">{createdDate}</Moment>
  if (moment(new Date()).diff(moment(createdDate), 'minutes') < 3) {
    result = 'Just Now'
  } else if (moment(new Date()).diff(moment(createdDate), 'minutes') < 60) {
    result = moment(new Date()).diff(moment(createdDate), 'minutes') + ' minutes ago'
  } else if (moment(new Date()).diff(moment(createdDate), 'hours') < 24) {
    result = moment(new Date()).diff(moment(createdDate), 'hours') + ' hours ago'
  } else if (moment(new Date()).diff(moment(createdDate), 'days') < 7) {
    result = moment(new Date()).diff(moment(createdDate), 'days') + ' days ago'
  } else if (moment(new Date()).diff(moment(createdDate), 'weeks') < 5) {
    result = moment(new Date()).diff(moment(createdDate), 'weeks') + ' weeks ago'
  } else if (moment(new Date()).diff(moment(createdDate), 'months') < 12) {
    result = moment(new Date()).diff(moment(createdDate), 'months') + ' months ago'
  } else if (moment(new Date()).diff(moment(createdDate), 'months') < 12) {
    result = moment(new Date()).diff(moment(createdDate), 'months') + ' months ago'
  } else {
    result = <Moment format="DD/MM/YYYY HH:mm:ss">{createdDate}</Moment>
  }
  return result
}

export default {
  createTimeDiffTag
}
